import { useMutation } from '@tanstack/react-query';
import { useOutletContext } from 'react-router';
import { useIotsApi } from '../../../contexts/iotsApi';
import { useLanguage } from '../../../contexts/language';
import { Operator } from '../../../types/operator';
import OperatorForm from './OperatorForm';
import { useSnackbar } from 'notistack';
import { OperatorTemplateSubPageContext } from './types';
import useApiErrorMessageGetter from '../../../hooks/useApiErrorMessage';

const EditOperatorPage = () => {
  const { operator, isFetching, refetch, updateContextOperator } =
    useOutletContext<OperatorTemplateSubPageContext>();
  const { updateOperator } = useIotsApi();

  const { t } = useLanguage();

  const updateOperatorMutation = useMutation({
    mutationFn: updateOperator,
  });

  const { enqueueSnackbar } = useSnackbar();
  const getErrorMessage = useApiErrorMessageGetter();

  const isLoading = isFetching || updateOperatorMutation.isPending;

  return (
    <OperatorForm
      onSubmit={(values, callback) => {
        const updatedOperator: Operator = {
          ...operator,
          name: values.companyName,
          webSite: values.website || undefined,
          trnVatNumber: values.trnVatNumber,
          tcanNumber: values.tcanNumber,
          croNumber: values.croNumber,
          addressLine1: values.addressLine1,
          addressLine2: values.addressLine2,
          addressLine3: values.addressLine3,
          county: values.county,
          eircode: values.eirCode,
          phone: values.companyPhoneNumber,
          email: values.companyEmailAddress,
        };

        updateOperatorMutation.mutate(updatedOperator, {
          onSuccess: () => {
            enqueueSnackbar({
              variant: 'success',
              message: t('content.operator-update-success'),
            });
            updateContextOperator(updatedOperator);
            refetch();
            callback();
          },
          onError: error => {
            enqueueSnackbar({
              variant: 'error',
              message: getErrorMessage(
                error,
                t('content.operator-update-error'),
              ),
            });
            updateOperatorMutation.reset();
          },
        });
      }}
      isLoading={isLoading}
      operator={operator}
    />
  );
};

export default EditOperatorPage;
